<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                    <div class="nk-block-between g-3">
                        <div class="nk-block-head-content">
                            <h3 class="nk-block-title page-title">Tickets</h3>
                            <div class="nk-block-des text-soft">
                                <p>You have total {{rowCount}} Tickets.</p>
                            </div>
                        </div><!-- .nk-block-head-content -->
                        <div class="nk-block-head-content" v-if="roleName=='Customer'">
                            <a href="javascript:void(0)" v-on:click="AddSignup()" class="btn btn-primary" data-bs-toggle="dropdown">Create Ticket</a>

                        </div><!-- .nk-block-head-content -->
                    </div><!-- .nk-block-between -->
                </div><!-- .nk-block-head -->
                <div class="nk-block">
                    <div class="card card-bordered card-stretch">
                        <div class="card-inner-group">
                            <div class="card-inner p-0">
                                <table class="table table-orders">
                                    <thead class="tb-odr-head">
                                        <tr class="tb-odr-item">
                                            <th class="tb-odr-info">
                                                <span class="tb-odr-id">Ticket</span>
                                                <span class="tb-odr-id d-none d-md-inline-block">Subject</span>
                                                <span class="tb-odr-id d-none d-md-inline-block">Creation Date</span>
                                                <span class="tb-odr-date d-none d-md-inline-block">Last Updated</span>
                                            </th>
                                            <th class="tb-odr-amount">
                                                <span class="tb-odr-total">Priority</span>
                                                <span class="tb-odr-status d-none d-md-inline-block">Status</span>
                                            </th>
                                            <th class="tb-odr-action" style="padding-left:0.5rem; padding-right:0.5rem;">&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody class="tb-odr-body">
                                        <tr v-for="(details) in userList" v-bind:key="details.id" class="tb-odr-item">
                                            <td class="tb-odr-info">
                                                <span class="tb-odr-id"><a v-on:click="CorrespondenceChat(details)" href="javascript:void(0)">{{details.code}} <br /> <span v-if="roleName=='Super Admin' || roleName=='Admin' || roleName=='Manager'">{{details.userName}}</span></a></span>
                                                <span class="tb-odr-id">{{details.subject}}</span>
                                                <span class="tb-odr-id">{{getDate(details.date)}} </span>
                                                <span class="tb-odr-date">{{getDate(details.lastUpdate)}} </span>
                                            </td>
                                            <td class="tb-odr-amount">
                                                <span class="tb-odr-total">
                                                    <span class="amount">{{details.priority}} </span>
                                                </span>
                                                <span class="tb-odr-status">
                                                    <span v-if="details.alert && roleName!='Customer'" class="badge rounded-pill bg-danger" style="margin-right: 5px;">New</span> 
                                                    <span v-if="details.alertFrom && roleName=='Customer'" class="badge rounded-pill bg-danger" style="margin-right: 5px;">New</span> 

                                                    <span v-if="details.status" class="badge rounded-pill bg-info">Processing</span>
                                                    <span v-else class="badge rounded-pill bg-danger">Close</span>
                                                </span>
                                            </td>
                                            <td class="tb-odr-action" style="padding-left:0.5rem; padding-right:0.5rem;">
                                                <a v-on:click="CorrespondenceChat(details)" class="text-soft dropdown-toggle btn btn-icon btn-trigger"><em class="icon ni ni-more-h"></em></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div><!-- .card-inner -->
                            <div class="card-inner">
                                <div class="nk-block-between-md g-3">
                                    <div class="g">
                                        <div class="pagination justify-content-center justify-content-md-start">
                                            <div class="overflow-auto" v-on:click="getPage()">
                                                <b-pagination pills size="md" v-model="currentPage"
                                                              :total-rows="rowCount"
                                                              :per-page="10"
                                                              first-text="First"
                                                              prev-text="Previous"
                                                              next-text="Next"
                                                              last-text="Last"></b-pagination>
                                            </div>
                                        </div><!-- .pagination -->
                                    </div>
                                    <div class="g">
                                        <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3 text-capitalize">
                                            <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                            <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                        </div>
                                    </div><!-- .pagination-goto -->
                                </div><!-- .nk-block-between -->
                            </div><!-- .card-inner -->
                        </div><!-- .card-inner-group -->
                    </div><!-- .card -->
                </div><!-- .nk-block -->
            </div>
        </div>
    </div>

</template>

<script>
    import moment from "moment";

    export default {
        name: 'UniLevelBonus',
        data: function () {
            return {
                roleName: '',
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                pageSize: '',
                isDesc: true,

                loading: false,
                userList: [],

            }
        },
        watch: {
            search: function (val) {
                this.GetData(val, 1);
            }
        },
        methods: {
            getDate: function (date) {
                return moment(date).format('D-MM-YYYY HH:mm');
            },

            AddSignup: function () {
                this.$router.push('/CreateTicket')
            },

            getPageSize: function (isDesc) {
                this.isDesc = isDesc;
                this.getPage();
            },

            getPage: function () {
                this.GetData(this.search, this.currentPage);
            },

            GetData: function (search, currentPage) {
                var root = this;
                var url = '/Support/SupportList?searchTerm=' + search + '&pageNumber=' + currentPage + '&isDesc=' + this.isDesc;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userList = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                    }
                }).catch(error => {
                    console.log(error)
                    root.$swal.fire({
                        icon: 'error',
                        type: 'error',
                        title: 'Error',
                        text: "Something Went Wrong",
                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                    });
                }).finally(() => root.loading = false);
            },


            CorrespondenceChat: function (data) {
                this.$router.push({
                    path: '/Correspondence',
                    query: { data: data }
                })
            },

        },
        created: function () {
            this.roleName = localStorage.getItem('RoleName');
        },
        mounted: function () {
            this.GetData(this.search, 1);
        },
    }
</script>